import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { Phone, Mail } from "lucide-react";

const VIDI_LOGO = "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/fkw9y91b_logo%20vidi%20communication.png";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer
      data-testid="footer"
      style={{
        background: "#1a1a1a",
        color: "#f0f0f0",
        padding: "64px 48px 40px",
      }}
    >
      <div style={{
        maxWidth: "1200px", margin: "0 auto",
        display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "48px",
      }}>
        {/* Brand */}
        <div>
        <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" }}>
          <img
            src={VIDI_LOGO}
            alt="ViDi Communications"
            style={{
              height: "108px", width: "108px",
              borderRadius: "10px",
              objectFit: "contain",
              backgroundColor: "transparent",
              display: "block",
            }}
          />
        </div>
          <p style={{
            fontFamily: "'Monotype Corsiva', 'Cormorant Garamond', cursive",
            fontStyle: "italic", fontWeight: 600,
            fontSize: "16px", color: "#888",
            margin: "0", lineHeight: 1.6,
          }}>
            {t.footer.tagline}
          </p>
        </div>

        {/* Contact */}
        <div>
          <h4 style={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 600, fontSize: "11px",
            color: "#ffc84d",
            margin: "0 0 20px 0",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          }}>
            Contact
          </h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {[
              { href: "tel:+34633863789", icon: <Phone size={13} strokeWidth={1.5} style={{ color: "#ffc84d", flexShrink: 0 }} />, text: "+34 633 863 789" },
              { href: "tel:+393347196432", icon: <Phone size={13} strokeWidth={1.5} style={{ color: "#ffc84d", flexShrink: 0 }} />, text: "+39 334 719 6432" },
              { href: "mailto:vidicommunications@gmail.com", icon: <Mail size={13} strokeWidth={1.5} style={{ color: "#f65151", flexShrink: 0 }} />, text: "vidicommunications@gmail.com" },
            ].map((item) => (
              <a key={item.href} href={item.href} style={{
                display: "flex", alignItems: "center", gap: "10px",
                color: "#bbb", textDecoration: "none",
                fontFamily: "'Poppins', sans-serif", fontSize: "13px",
                transition: "color 0.2s ease",
              }}
                onMouseEnter={(e) => e.currentTarget.style.color = "#fff"}
                onMouseLeave={(e) => e.currentTarget.style.color = "#bbb"}
              >
                {item.icon}
                {item.text}
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 style={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 600, fontSize: "11px",
            color: "#ffc84d",
            margin: "0 0 20px 0",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          }}>
            Services
          </h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {[t.nav.strategy, t.nav.contentCreation, t.nav.campaigns, t.nav.webAutomation].map((s) => (
              <span key={s} style={{ fontFamily: "'Poppins', sans-serif", fontSize: "13px", color: "#666" }}>{s}</span>
            ))}
          </div>
        </div>
      </div>

      <div style={{
        maxWidth: "1200px", margin: "48px auto 0",
        paddingTop: "24px",
        borderTop: "1px solid #2a2a2a",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        flexWrap: "wrap", gap: "12px",
      }}>
        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: "12px", color: "#444" }}>
          © {new Date().getFullYear()} ViDi Communications. All rights reserved.
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
          <a
            href="https://www.iubenda.com/privacy-policy/55166439"
            className="iubenda-white iubenda-noiframe iubenda-embed"
            title="Privacy Policy"
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: "12px", color: "#555", textDecoration: "none" }}
          >
            Privacy Policy
          </a>
          <span style={{
            fontFamily: "'Monotype Corsiva', 'Cormorant Garamond', cursive",
            fontStyle: "italic", fontWeight: 600, fontSize: "13px", color: "#444",
          }}>
            Strategy · Creativity · Growth
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
